import { Presenter } from '~/framework/Presenter';
import { User } from '~/state/mainAppState';

export interface PresentableCompanyInfo {
  companyId: string;
  companyName: string;
  initials: string;
  email: string;
  phoneNumber: string;
  language?: string;
}

export class CompanyInfoPresenter extends Presenter<PresentableCompanyInfo> {
  protected createModel = (state: User): PresentableCompanyInfo => {
    return {
      companyName: state.companyInfo?.name || '',
      companyId: state.companyInfo?.id || '',
      initials: this.getInitials(state.companyInfo?.name),
      email: state.companyInfo?.email || '',
      phoneNumber: this.formatPhoneNumber(state.companyInfo?.phoneNumber) || '',
      language: state.companyInfo?.language || '',
    };
  };

  private formatPhoneNumber = (phone?: string) => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4];
    }
    return phone;
  };

  private getInitials = (name?: string) => {
    return (
      name
        ?.split(' ')
        .slice(0, 2)
        .map((e) => e[0])
        .join('')
        .toUpperCase() || ''
    );
  };
}
